import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { Pie } from 'react-chartjs-2';
import 'chart.js/auto';  // To avoid the "react-chartjs-2" issue
import DashboardNavbar from "../dashboardNavbar"

export default function Result() {
  const location = useLocation();
  const { resultDetails } = location.state || {};
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const menuItems = [];

  const apiUrl = process.env.REACT_APP_API_URL;
  const getBasicAuthHeader = () => {
    const username = process.env.REACT_APP_API_USERNAME;
    const password = process.env.REACT_APP_API_PASSWORD;
    const encodedCredentials = btoa(`${username}:${password}`);
    return `Basic ${encodedCredentials}`;
  };

  const fetchResultDetails = async () => {
    if (resultDetails) {
      setLoading(true);
      try {
        const resultId = resultDetails.resultId;
        const response = await axios.get(apiUrl + `/api/resultOfSingleStudent/${resultId}`, {
          headers: {
            'Content-Type': "application/json",
            "Accept": "*/*",
            "Access-Control-Allow-Origin": "*",
            'Authorization': getBasicAuthHeader(),
          },
        });
        setLoading(false);
        setResult(response.data);
      } catch (error) {
        setLoading(false);
        console.error("Error:", error.response ? error.response.data : error.message);
      }
    }
  };
  

  useEffect(() => {
    fetchResultDetails();
  }, []); // Empty dependency array ensures this runs once after initial render

  if (loading) {
    return <p>Loading...</p>;
  }

  if (!result) {
    return <p>No result data available.</p>;
  }

  const pieData = {
    labels: result.domainPerformance?.map(item => item.domainName || item.domainId) || [],
    datasets: [{
      data: result.domainPerformance?.map(item => item.totalQuestion) || [],
      backgroundColor: [
        '#FF6384',
        '#36A2EB',
        '#FFCE56',
        '#4BC0C0',
        '#9966FF',
        '#FF9F40',
        '#FFCD56',
        '#4D4D4D'
      ],
    }]
  };

  return (
    <>
    <DashboardNavbar menuItems={menuItems} />
    <div style={styles.container}>
      <div style={styles.chartContainer}>
        <Pie data={pieData} options={{ responsive: true, maintainAspectRatio: false }} />
      </div>
      <div style={styles.summaryContainer}>
        <div style={styles.summaryItem}>
          <h3>Score</h3>
          <p>{result.score}/{result.totalMarks}</p>
        </div>
        <div style={styles.summaryItem}>
          <h3>Question Attempted</h3>
          <p>{result.attemptedQuestions}/{result.totalQuestions}</p>
        </div>
        <div style={styles.summaryItem}>
          <h3>Correct Answers</h3>
          <p>{result.correctAnswers}/{result.totalQuestions}</p>
        </div>
      </div>
      <div style={styles.tableContainer}>
        <h3>Domain Performance</h3>
        <table style={styles.table}>
          <thead>
            <tr>
              <th>Domain</th>
              <th>Correct Answers</th>
              <th>Total Questions</th>
            </tr>
          </thead>
          <tbody>
            {result.domainPerformance?.map((domain, index) => (
              <tr key={index}>
                <td style={styles.tableCell}>{domain.domainName || domain.domainId}</td>
                <td style={styles.tableCell}>{domain.correctAnswers}</td>
                <td style={styles.tableCell}>{domain.totalQuestion}</td>
              </tr>
            )) || <tr><td colSpan="3">No data available</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
    </>
  );
}

const styles = {
  container: {
    maxWidth: 1240,
    margin: '0 auto',
    background: 'oklch(1 0 0)',
    padding: '22px',
    borderRadius: '16px',
    boxShadow: '0 1px 2px rgba(17,20,38,.04), 0 6px 16px -4px rgba(17,20,38,.10)',
    border: '1px solid transparent',
    fontFamily: '"Hanken Grotesk", system-ui, sans-serif',
    color: 'oklch(0.26 0.02 268)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  chartContainer: {
    width: '100%',
    height: '200px',
    marginBottom: '20px'
  },
  summaryContainer: {
    display: 'flex',
    justifyContent: 'space-around',
    width: '100%',
    flexWrap: 'wrap',
    marginBottom: '20px'
  },
  summaryItem: {
    flex: '1 1 30%',
    textAlign: 'center',
    marginBottom: '10px'
  },
  tableContainer: {
    width: '100%',
    overflowX: 'auto'
  },
  table: {
    width: '100%',
    borderCollapse: 'collapse',
    textAlign: 'center'
  },
  tableCell: {
    border: '1px solid oklch(0.915 0.006 260)',
    padding: '10px'
  },
};
